let Ccp = {
    init: function () {
        if ($('body.ccp').length) {
            this.bind();
        }
    },

    bind: function () {
        this.subCategories();
        this.listenForFieldChanges();
        this.toggleFields();
        this.form();
    },

    subCategories() {
        $(document).on('click', '.sub-category', function () {
            const id = $(this).data('id');
            const parentId = $(this).data('parent');
            const entity = $(this).data('entity');
            const container = $('#' + entity + 'Container' + parentId);

            if ($(this).prop('checked')) {
                container.append('<input type="hidden" name="' + entity + '[]" value="' + id + '" id="' + entity + id + '">');
            } else {
                container.find('#' + entity + id).remove();
            }

            $('#' + entity + parentId + 'Row .selected').text(container.find('input[type=hidden]').length);
        });
    },

    listenForFieldChanges() {
        let _this = this;

        $(document).on('change', '[name=status]', function () {
            _this.toggleFields();
        });
        $(document).on('change', '[name=type]', function () {
            _this.toggleFields();
        });
    },

    toggleFields() {
        let status = $('input[name=status]:checked').val();
        let type = $('input[name=type]:checked').val();

        if (status === 'operational') {
            $('#numberOfOperatorsContainer').show();
            $('#launchDateContainer').show();
            $('#aeoOperatorsNumberContainer').show();
            $('#legislationContainer').show();
            $('#aeoComparisonForMraContainer').show();
            $('#mraAdditionalInformationContainer').show();
            $('#furtherPlansContainer').show();
            $('#furtherPlansDetailsContainer').show();
        } else {
            $('#launchDateContainer').hide();
            $('#aeoOperatorsNumberContainer').hide();
            $('#legislationContainer').hide();
            $('#aeoComparisonForMraContainer').hide();
            $('#mraAdditionalInformationContainer').hide();
            $('#furtherPlansContainer').hide();
            $('#furtherPlansDetailsContainer').hide();
        }

        if (status === 'operational' && type === 'multi_tier') {
            $('#mraOperatorsNumberContainer').show();
        } else {
            $('#mraOperatorsNumberContainer').hide();
        }

        if (status === 'development') {
            $('#implementationPlanContainer').show();
            $('#numberOfOperatorsContainer').hide();
        } else {
            $('#implementationPlanContainer').hide();
            $('#numberOfOperatorsContainer').show();
        }

        if (status === undefined) {
            $('#numberOfOperatorsContainer').hide();
        }
    },

    form() {
        $(document).on('click', 'button[type=submit]', function () {
            const action = $(this).data('action');

            if (action === 'submit_to_wco') {
                Swal.fire({
                    title: 'Are you sure?',
                    showCancelButton: true,
                    confirmButtonText: 'Continue',
                    cancelButtonText: 'Cancel',
                    icon: 'warning'
                }).then((result) => {
                    if (result.value) {
                        $('#aeoForm #action').val(action);
                        $('#aeoForm #processing_status').val('submitted');
                        $('#aeoForm').submit();
                    } else {
                        $('input[type="submit"]').removeAttr('disabled');
                        $('button[type="submit"]').removeAttr('disabled');
                    }
                });
            } else {
                $('#aeoForm #action').val(action);
                $('#aeoForm').submit();
            }
        });
    },
};


$().ready(() => {
    window.Ccp = Ccp;
    window.Ccp.init();
});
